import React, { useCallback, useMemo, useState } from 'react';
import IndexTable from '@dex/bubl-dash/src/lib/components/IndexTable/IndexTable';
import LeagueSeasonPlayerSettings from '../../LeagueSeasonPlayer/LeagueSeasonPlayerSettings';
import Button from '@dex/bubl-dash/src/lib/components/Button/Button';
import LeagueSeasonTeamAddNewPlayer from '../../LeagueSeasonTeam/Components/LeagueSeasonTeamAddNewPlayer';

const LeagueSeasonManagePlayers: React.FC<any> = (props: any) => {

    const { data } = props;

    const [key, setKey] = useState(0);

    const [showAddNew, setShowAddNew] = useState(false);

    const [tableState, setTableState] = useState({ search: undefined, where: undefined, order: undefined, skip: undefined });

    const preFetchFilters = useCallback((routeName, params, users) => {

        const filters = LeagueSeasonPlayerSettings.indexFetchParams(routeName, params, users);

        filters.where.seasonId = data.id;

        return filters;

    }, []);

    const handleClose = useCallback(() => {

        setKey(key + 1);
        setShowAddNew(false);

    }, [key])

    const getColumns = useCallback((routeName, params, users) => {

        const columns = LeagueSeasonPlayerSettings.indexColumns(routeName, params, users);

        columns.map((column, index) => {

            if (column.key === "host") delete (columns[index]);
            else if (column.key === "season") delete (columns[index]);
            else if (column.key === "league") delete (columns[index]);
            else if (column.key === "created") delete (columns[index]);

            return column;

        });

        return columns;

    }, []);

    return useMemo(() => (

        <>

            <IndexTable
                key={key}
                title={"Players"}
                getFetch={LeagueSeasonPlayerSettings.indexFetch}
                getColumns={getColumns}
                preFetchFilters={preFetchFilters}
                getQuickSearch={LeagueSeasonPlayerSettings.indexQuickSearch}
                getSearchFields={LeagueSeasonPlayerSettings.indexSearchFields}
                routeParams={tableState}
                manageState={setTableState}
                hideTrashSwitch={true}
                actionButtons={() => (
                    <>
                        <Button
                            label={"Add New Player"}
                            size="small"
                            type="light"
                            onClick={setShowAddNew.bind(null, true)}
                        />
                    </>
                )}
            />

            {showAddNew &&
                <LeagueSeasonTeamAddNewPlayer
                    onClose={handleClose}
                    data={{ seasonId: data.id }}
                />
            }

        </>

    ), [data, tableState, showAddNew, key]);

}

export default LeagueSeasonManagePlayers;
